import { __awaiter, __decorate, __extends, __generator, __metadata, __param } from "tslib";
import { Aggregate } from '../../base/ddd-types/aggregate';
import { dataFieldNamingHandler, exceptionHandler, fireEvent, parseArrayData, parseObjectData, } from '../../base/decorators';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { Notify } from '../entity/notify';
import { NotificationRepository } from '../repository/notification-repository';
import { Emitter } from '@tencent/ark-utils/lib/event';
import { UnreadInfo } from '../value-object/unread-info';
// unreadSumCount更新事件名
var NOTIFY_UNREAD_INFO_DID_UPDATE_EVENT_NAME = 'mOnNotifyUnreadInfoDidUpdated';
// 未读数属性key
var UNREAD_INFO_PREPOTRY_KEY = 'unreadInfo';
// 未读数属性key
var NOTIFYS_ALL_KEY = 'notifysAll';
// 未读数属性key
var NOTIFY_CURRENT_KEY = 'notifysCurrent';
// 被解析的字段名
var ARRAY_PREPOTRY_KEY = 'list';
var NotificationAggregate = /** @class */ (function (_super) {
    __extends(NotificationAggregate, _super);
    function NotificationAggregate(id, docMetaDomainService, networkRequest) {
        var _this = _super.call(this, id) || this;
        _this.docMetaDomainService = docMetaDomainService;
        _this.networkRequest = networkRequest;
        // 未读审批通知红点数
        _this.unreadInfo = new UnreadInfo({});
        // 所有文档的权限审批通知
        _this.notifysAll = [];
        // 当前文档的权限审批通知
        _this.notifysCurrent = [];
        _this.mOnNotifyUnreadInfoDidUpdated = new Emitter();
        _this.onNotifyUnreadInfoDidUpdated = _this.mOnNotifyUnreadInfoDidUpdated.event;
        _this.notificationRepository = new NotificationRepository(networkRequest);
        return _this;
    }
    // 发送事件
    NotificationAggregate.prototype.notifyGetNum = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notificationRepository.notifyGetNum()];
            });
        });
    };
    NotificationAggregate.prototype.notifyList = function (start) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // 没有start字段，说明请求的是第一页数据， 则清空数组
                if (!start) {
                    this.notifysAll = [];
                }
                return [2 /*return*/, this.notificationRepository.notifyList(start)];
            });
        });
    };
    NotificationAggregate.prototype.currentDocNotifyList = function (start) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // 没有start字段，说明请求的是第一页数据， 则清空数组
                if (!start) {
                    this.notifysCurrent = [];
                }
                return [2 /*return*/, this.notificationRepository.currentDocNotifyList(
                    // domainId & padId domain 服务内部消化
                    this.docMetaDomainService.docMetaEntity.padInfo.domainId, this.docMetaDomainService.docMetaEntity.padInfo.padId, start)];
            });
        });
    };
    NotificationAggregate.prototype.authSet = function (domainId, localPadId, notifyId, setInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notificationRepository.authSet(domainId, localPadId, notifyId, setInfo)];
            });
        });
    };
    NotificationAggregate.prototype.authApplyCheck = function (domainId, localPadId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notificationRepository.authApplyCheck(domainId, localPadId)];
            });
        });
    };
    NotificationAggregate.prototype.notifyDelete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notificationRepository.notifyDelete(id)];
            });
        });
    };
    NotificationAggregate.prototype.transownerAccept = function (domainId, localPadId, notifyId, message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notificationRepository.transownerAccept(domainId, localPadId, notifyId, message)];
            });
        });
    };
    NotificationAggregate.prototype.transownerReject = function (domainId, localPadId, notifyId, message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notificationRepository.transownerReject(domainId, localPadId, notifyId, message)];
            });
        });
    };
    NotificationAggregate.prototype.clearUnreadInfo = function () {
        this.unreadInfo = new UnreadInfo({});
        this.mOnNotifyUnreadInfoDidUpdated.fire({ unreadInfo: this.unreadInfo });
    };
    __decorate([
        fireEvent(NOTIFY_UNREAD_INFO_DID_UPDATE_EVENT_NAME, UNREAD_INFO_PREPOTRY_KEY)
        // 解析数据
        ,
        parseObjectData(UnreadInfo.prototype.constructor, UNREAD_INFO_PREPOTRY_KEY)
        // 异常处理
        ,
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "notifyGetNum", null);
    __decorate([
        parseArrayData(Notify.prototype.constructor, NOTIFYS_ALL_KEY, ARRAY_PREPOTRY_KEY),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "notifyList", null);
    __decorate([
        parseArrayData(Notify.prototype.constructor, NOTIFY_CURRENT_KEY, ARRAY_PREPOTRY_KEY),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "currentDocNotifyList", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String, Object]),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "authSet", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "authApplyCheck", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "notifyDelete", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String, Object]),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "transownerAccept", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String, Object]),
        __metadata("design:returntype", Promise)
    ], NotificationAggregate.prototype, "transownerReject", null);
    NotificationAggregate = __decorate([
        __param(1, IDocMetaDomainService),
        __param(2, INetworkRequestService),
        __metadata("design:paramtypes", [String, Object, Object])
    ], NotificationAggregate);
    return NotificationAggregate;
}(Aggregate));
export { NotificationAggregate };
